import React from 'react';
import { Link } from 'react-router-dom';
import { Phone, Mail, MapPin, Clock, Facebook, Instagram } from 'lucide-react';
import { businessInfo } from '../mock';

const Footer = () => {
  return (
    <footer className="bg-sage-900 text-white">
      <div className="container mx-auto px-4 py-12">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-8">
          {/* About */}
          <div>
            <h3 className="font-bold text-lg mb-4">Pups & Dreams</h3>
            <p className="text-xs text-sage-300 mb-4">Spa & Academy</p>
            <p className="text-sage-300 text-sm leading-relaxed mb-4">
              Professional dog grooming and training academy in Denton, Manchester. 
              Where every pup is treated with love and care.
            </p>
            <div className="flex items-center gap-1 text-amber-400 mb-2">
              {[...Array(5)].map((_, i) => (
                <svg key={i} className="w-5 h-5 fill-current" viewBox="0 0 20 20">
                  <path d="M10 15l-5.878 3.09 1.123-6.545L.489 6.91l6.572-.955L10 0l2.939 5.955 6.572.955-4.756 4.635 1.123 6.545z" />
                </svg>
              ))}
              <span className="ml-2 text-white font-semibold">{businessInfo.rating.stars}</span>
              <span className="text-sage-300 text-sm">({businessInfo.rating.count}+ reviews)</span>
            </div>
          </div>

          {/* Quick Links */}
          <div>
            <h3 className="font-bold text-lg mb-4">Quick Links</h3>
            <ul className="space-y-2">
              <li>
                <Link to="/" className="text-sage-300 hover:text-white transition-colors text-sm">
                  Home
                </Link>
              </li>
              <li>
                <Link to="/academy" className="text-sage-300 hover:text-white transition-colors text-sm">
                  Academy
                </Link>
              </li>
              <li>
                <Link to="/services" className="text-sage-300 hover:text-white transition-colors text-sm">
                  Grooming Services
                </Link>
              </li>
              <li>
                <Link to="/team" className="text-sage-300 hover:text-white transition-colors text-sm">
                  Meet Our Owners
                </Link>
              </li>
              <li>
                <Link to="/reviews" className="text-sage-300 hover:text-white transition-colors text-sm">
                  Customer Reviews
                </Link>
              </li>
              <li>
                <Link to="/contact" className="text-sage-300 hover:text-white transition-colors text-sm">
                  Contact Us
                </Link>
              </li>
            </ul>
          </div>

          {/* Contact Info */}
          <div>
            <h3 className="font-bold text-lg mb-4">Contact Us</h3>
            <ul className="space-y-3">
              <li>
                <a 
                  href={`tel:${businessInfo.phone}`}
                  className="flex items-start gap-2 text-sage-300 hover:text-white transition-colors text-sm group"
                >
                  <Phone size={16} className="mt-0.5 flex-shrink-0 group-hover:text-sage-400" />
                  <span>{businessInfo.phone}</span>
                </a>
              </li>
              <li>
                <a 
                  href={`mailto:${businessInfo.email}`}
                  className="flex items-start gap-2 text-sage-300 hover:text-white transition-colors text-sm group"
                >
                  <Mail size={16} className="mt-0.5 flex-shrink-0 group-hover:text-sage-400" />
                  <span className="break-all">{businessInfo.email}</span>
                </a>
              </li>
              <li>
                <div className="flex items-start gap-2 text-sage-300 text-sm">
                  <MapPin size={16} className="mt-0.5 flex-shrink-0" />
                  <span>{businessInfo.address.full}</span>
                </div>
              </li>
            </ul>
          </div>

          {/* Opening Hours */}
          <div>
            <h3 className="font-bold text-lg mb-4">Opening Hours</h3>
            <ul className="space-y-2">
              <li className="flex items-center gap-2 text-sage-300 text-sm">
                <Clock size={16} className="flex-shrink-0" />
                <div>
                  <div className="font-medium text-white">Mon - Fri</div>
                  <div>9:00 AM - 6:00 PM</div>
                </div>
              </li>
              <li className="flex items-center gap-2 text-sage-300 text-sm">
                <Clock size={16} className="flex-shrink-0" />
                <div>
                  <div className="font-medium text-white">Saturday</div>
                  <div>9:00 AM - 3:00 PM</div>
                </div>
              </li>
              <li className="flex items-center gap-2 text-sage-300 text-sm">
                <Clock size={16} className="flex-shrink-0" />
                <div>
                  <div className="font-medium text-white">Sunday</div>
                  <div>Closed</div>
                </div>
              </li>
            </ul>
            <div className="mt-4 flex gap-3">
              <a 
                href="#" 
                className="w-9 h-9 bg-sage-800 rounded-full flex items-center justify-center hover:bg-sage-700 transition-colors"
                aria-label="Facebook"
              >
                <Facebook size={18} />
              </a>
              <a 
                href="https://www.instagram.com/pupsanddreams_academy/"
                target="_blank"
                rel="noopener noreferrer"
                className="w-9 h-9 bg-sage-800 rounded-full flex items-center justify-center hover:bg-sage-700 transition-colors"
                aria-label="Instagram"
              >
                <Instagram size={18} />
              </a>
            </div>
          </div>
        </div>

        {/* Bottom Bar */}
        <div className="border-t border-sage-800 mt-8 pt-6 text-center text-sage-400 text-sm">
          <p>&copy; {new Date().getFullYear()} Pups & Dreams Spa & Academy Ltd. All rights reserved.</p>
          <p className="mt-1">Registered in England and Wales</p>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
